const GolfBallIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "9", r: "7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.0078 7L9.99883 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18C10.5 18 12 19.4617 12 22C12 19.4617 13.5 18 15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { GolfBallIcon as default };
//# sourceMappingURL=GolfBallIcon.js.map
